import type { SearchLeg } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

const getLegLocationCodes = (legs: SearchLeg[]) => {
  const legLocationCodes: Record<string, string> = {};
  legs.forEach((leg, index) => {
    if (leg.origin && leg.origin.id) {
      legLocationCodes[`originCodeLeg${index + 1}`] = leg.origin.id;
    }

    if (leg.destination && leg.destination.id) {
      legLocationCodes[`destinationCodeLeg${index + 1}`] = leg.destination.id;
    }
  });
  return legLocationCodes;
};

const getChildrenFromChildAges = (childAges: number[]): number =>
  childAges.reduce((acc: number, childAge: number) => (childAge >= 2 ? acc + 1 : acc), 0);

const getInfantsFromChildAges = (childAges: number[]): number =>
  childAges.reduce((acc: number, childAge: number) => (childAge < 2 ? acc + 1 : acc), 0);

export { getLegLocationCodes, getChildrenFromChildAges, getInfantsFromChildAges };
